import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import type { ReactElement } from 'react';
import type { NumberInputFrom } from '@tencent/wb-ext-form';

export interface IRegulateFeature extends IBaseDrawerFeature {
    ragulateProps: any;
    readonly ragulateInfo: any;
    readonly sharpenSoften: number;
    readonly brightness: number;
    readonly contrast: number;
    renderReset(): ReactElement;
    handleRegulateChange(value: number, type: string, from?: NumberInputFrom, dragEnd?: boolean)
}

export const IRegulateFeature = Symbol.for('feature:drawer-regulate');

DynamicLoaderRegistry.merge(IRegulateFeature, {
    useFactory: async () => {
        const { RegulateFeature } = await import('./regulate-feature');
        return RegulateFeature;
    },
    on: loadTask,
});
